import {
  Avatar,
  Box,
  Button,
  ColumnDatas,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  InputField,
  Modal,
  Radio,
  Table,
  Tabs,
  Tooltip,
  Tree,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import utilsCommon from "../../shared/utils/common";
import useCheckboxGroup from "fds/src/hooks/useCheckboxGroup";
import useAdminDeptStore from "../../redux/dispatcher/useAdminDeptStore";
import useAdminPositionRoleStore from "../../redux/dispatcher/useAdminPositionRoleStore";

import { getAdminInfoFromLocalStorage } from "../../shared/utils/auth";
import {
  ActiveUser,
  AddDepartment,
  AddDeptParam,
  ChangeDeptNameParam,
  DeptInfo,
  DeptManagerParam,
  ExternalUser,
  TreeNode,
  User,
  UserDTO,
  UserPasswd,
  UserSearchResult,
} from "../../types/adminDept";
import { PositionOrRoleDto } from "../../types/adminPositionRole";
import { nanoid } from "@reduxjs/toolkit";
import { Member } from "../../types/workgroup";
import WorkgroupManagerIcon from "../../components/WorkgroupManagerIcon";
import readXlsxFile from "read-excel-file";
import AddExcelGroupModal from "./AddExcelGroupModal";
import DeleteUserOrDept from "./DeleteUserOrDept";

const AdminSetting: React.FC = () => {
  const ROOT_DEPT_CODE = "ae4fc0f5fd8f4142834c1ad4e929a514";
  const { t } = useTranslation();
  const toast = useToast();
  const inputFile = useRef<any>();
  const [leftTab, setLeftTab] = useState(0);
  const [userStatus, setUserStatus] = useState("ALL");
  const [tempSearchWord, setTempSearchWord] = useState("");
  const [searchWord, setSearchWord] = useState("");
  const [rightTab, setRightTab] = useState(0);
  const loginResult = getAdminInfoFromLocalStorage();
  const companyName = loginResult
    ? JSON.parse(loginResult).ecoCommonConfig?.companyName
    : "COMPANY";
  const {
    adminDeptStore,
    getDeptDetail,
    getDeptUsers,
    getDeptInfo,
    getDeptLists,
    getUserDetail,
    updateUserDept,
    updateExternalUserDept,
    addUserDept,
    getActiveInternalUserList,
    getActiveExternalUserList,
    getInternalUserList,
    getExternalUserList,
    downloadDeptFile,
    uploadDeptFile,
    updateDeptParent,
    updateDeptManager,
    deleteDept,
    deleteUser,
    addDept,
    userPasswdUpdate,
    userPasswdInit,
    changeDeptName,
  } = useAdminDeptStore();
  const { positionRoleState, getPositionList, getRoleList } =
    useAdminPositionRoleStore();
  const [expandValues, setExpandValues] = useState([
    ROOT_DEPT_CODE,
  ] as string[]);
  const [expandModalValues, setExpandModalValues] = useState([
    ROOT_DEPT_CODE,
  ] as string[]);
  const [targetData, setTargetData] = useState({
    id: ROOT_DEPT_CODE,
    name: companyName,
    type: "dept",
    state: "view", //view, userUserUpdate, deptUserUpdate, userInsert
  });
  const [height, setHeight] = useState(window.innerHeight - 260);
  const tableRef = useRef<HTMLDivElement>(null);

  const checkboxGroupInternal = useCheckboxGroup<string>();
  const checkboxGroupExternal = useCheckboxGroup<string>();
  const checkboxGroupSearchInternal = useCheckboxGroup<string>();
  const checkboxGroupSearchExternal = useCheckboxGroup<string>();
  const checkboxGroupActiveInternal = useCheckboxGroup<string>();
  const checkboxGroupActiveExternal = useCheckboxGroup<string>();

  const [deptDetail, setDeptDetail] = useState([] as DeptInfo[]);
  const [userDetail, setUserDetail] = useState([] as User[]);
  const [externalDetail, setExternalDetail] = useState([] as Member[]);
  const [internalActive, setInternalActive] = useState([] as ActiveUser[]);
  const [externalActive, setExternalActive] = useState([] as ActiveUser[]);
  const [internalSearch, setInternalSearch] = useState(
    [] as UserSearchResult[]
  );
  const [externalSearch, setExternalSearch] = useState([] as Member[]);
  const [userInfo, setUserInfo] = useState({} as User);
  const [editUserInfo, setEditUserInfo] = useState({} as User);
  const [externalUserInfo, setExternalUserInfo] = useState({} as ExternalUser);
  const [editExternalUserInfo, setEditExternalUserInfo] = useState(
    {} as ExternalUser
  );
  const [changeManager, setChangeManager] = useState({} as User);
  const [deleteUserInfo, setDeleteUserInfo] = useState([] as User[]);
  const [deleteDeptInfo, setDeleteDeptInfo] = useState({} as DeptInfo);
  const [moveTargetCode, setMoveTargetCode] = useState("");
  const [moveTargetName, setMoveTargetName] = useState("");
  const [moveUserInfo, setMoveUserInfo] = useState([] as User[]);
  const [moveDeptInfo, setMoveDeptInfo] = useState({} as DeptInfo);
  const [updateDeptInfo, setUpdateDeptInfo] = useState({} as DeptInfo);
  const [insertDeptInfo, setInsertDeptInfo] = useState({} as DeptInfo);
  const [buttonClick, changeButtonClick] = useState(0);
  const [password, setPassword] = useState({
    password1: "",
    password2: "",
    type: "RANDOM",
  });
  const [isNewPassword, setIsNewPassword] = useState(false);
  const [fileSelected, setFileSelected] = useState({} as any);
  const [selectedDeptList, setSelectedDeptList] = useState<AddDepartment[]>();
  const [showExcelModal, toggleExcelModal] = useState(false);

  useEffect(() => {
    getDeptLists();
    getPositionList();
    getRoleList();
  }, []);

  useEffect(() => {
    if (leftTab === 0) {
      selectNode({
        value: ROOT_DEPT_CODE,
        columnText: companyName,
        type: "dept",
      });
      setRightTab(0);
      setUserStatus("ALL");
      setExpandValues([ROOT_DEPT_CODE]);
      setTempSearchWord("");
      setSearchWord("");
    } else if (leftTab === 1) {
      selectNode({
        value: "EXTERNAL",
        columnText: t("admin.dept.externalUser"),
        type: "external",
      });
      setUserStatus("ALL");
      setExpandValues(["EXTERNAL"]);
      setTempSearchWord("");
      setSearchWord("");
    }
  }, [leftTab]);

  useEffect(() => {
    if (companyName !== "" && targetData.name === "") {
      setTargetData({ ...targetData, name: companyName });
    }
  }, [companyName]);

  useEffect(() => {
    const handleResize = () => {
      if (tableRef.current) {
        const rect = tableRef.current.getBoundingClientRect();
        setHeight(window.innerHeight - rect.top);
      }
    };

    const element = tableRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (element) {
        const rect = element.getBoundingClientRect();
        setHeight(window.innerHeight - rect.top);
      }
    });

    if (element) {
      resizeObserver.observe(element);
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (element) {
        resizeObserver.unobserve(element);
      }
    };
  }, []);

  const searchTree = (value: string): void => {
    getDeptDetail(value);
    getDeptUsers(value);
  };

  const getDeptManagerName = () => {
    return userDetail
      ? userDetail.filter(
          (item: any) => item.id === userDetail[0].dept.managerId
        )[0]
        ? userDetail.filter(
            (item: any) => item.id === userDetail[0].dept.managerId
          )[0].name
        : ""
      : "";
  };

  const doSearchWord = () => {
    if (tempSearchWord.trim() !== "") {
      if (leftTab === 0) {
        selectNode({
          value: tempSearchWord,
          columnText: t("admin.dept.internalUser"),
          type: "internal_search",
        });
        setExpandValues([tempSearchWord]);
      } else if (leftTab === 1) {
        selectNode({
          value: tempSearchWord,
          columnText: t("admin.dept.externalUser"),
          type: "external_search",
        });
        setExpandValues([tempSearchWord]);
      }
    } else {
      if (leftTab === 0) {
        if (userStatus === "ACTIVE") {
          selectNode({
            value: "INTERNAL_ACTIVE",
            columnText: t("admin.dept.internalUser"),
            type: "internal_active",
          });
          setExpandValues(["INTERNAL_ACTIVE"]);
        } else {
          selectNode({
            value: ROOT_DEPT_CODE,
            columnText: companyName,
            type: "company",
          });
          setExpandValues([ROOT_DEPT_CODE]);
        }
      } else if (leftTab === 1) {
        if (userStatus === "ACTIVE") {
          selectNode({
            value: "EXTERNAL_ACTIVE",
            columnText: t("admin.dept.externalUser"),
            type: "external_active",
          });
          setExpandValues(["EXTERNAL_ACTIVE"]);
        } else {
          selectNode({
            value: "EXTERNAL",
            columnText: t("admin.dept.externalUser"),
            type: "external",
          });
          setExpandValues(["EXTERNAL"]);
        }
      }
    }
    setSearchWord(tempSearchWord.trim());
  };

  const selectNode = async (value: any) => {
    setTargetData({
      id: value.value,
      name: value.columnText,
      type:
        value.value === ROOT_DEPT_CODE
          ? "dept"
          : value.value === "EXTERNAL"
          ? "external"
          : value.value === "INTERNAL_ACTIVE"
          ? "internal_active"
          : value.value === "EXTERNAL_ACTIVE"
          ? "external_active"
          : value.type === "internal_search"
          ? "internal_search"
          : value.type === "external_search"
          ? "external_search"
          : value.type === "company" && searchWord !== "" && leftTab === 0
          ? "internal_search"
          : value.type === "company" && searchWord !== "" && leftTab === 1
          ? "external_search"
          : value.type,
      state: "view",
    });
    if (value.value === "EXTERNAL") {
      const userResult: any = await getExternalUserList("");
      if (userResult.payload) {
        setExternalDetail(userResult.payload as Member[]);
      } else {
        setExternalDetail([] as Member[]);
      }

      setUserDetail([] as User[]);
      setDeptDetail([] as DeptInfo[]);
    } else if (value.value === "INTERNAL_ACTIVE") {
      const userResult: any = await getActiveInternalUserList();
      if (userResult.payload) {
        setInternalActive(userResult.payload as ActiveUser[]);
      } else {
        setInternalActive([] as ActiveUser[]);
      }
    } else if (value.value === "EXTERNAL_ACTIVE") {
      const userResult: any = await getActiveExternalUserList();
      if (userResult.payload) {
        setExternalActive(userResult.payload as ActiveUser[]);
      } else {
        setExternalActive([] as ActiveUser[]);
      }
    } else if (value.type === "internal_search") {
      const userResult: any = await getInternalUserList(value.value);
      if (userResult.payload.users) {
        setInternalSearch(userResult.payload.users as UserSearchResult[]);
      } else {
        setInternalSearch([] as UserSearchResult[]);
      }
    } else if (value.type === "external_search") {
      const userResult: any = await getExternalUserList(value.value);
      if (userResult.payload) {
        setExternalSearch(userResult.payload as Member[]);
      } else {
        setExternalSearch([] as Member[]);
      }
    } else if (value.value === ROOT_DEPT_CODE || value.type === "dept") {
      const userResult: any = await getDeptUsers(value.value);
      if (userResult.payload) {
        setUserDetail(userResult.payload.resp as User[]);
      } else {
        setUserDetail([] as User[]);
      }

      const deptResult: any = await getDeptDetail(value.value);
      if (deptResult.payload) {
        setDeptDetail(deptResult.payload.resp as DeptInfo[]);
      } else {
        setDeptDetail([] as DeptInfo[]);
      }
      setUserInfo({} as User);
    } else if (
      value.type === "user" ||
      value.type === "externalUser" ||
      value.type === "internalActiveUser" ||
      value.type === "externalActiveUser"
    ) {
      if (value.type === "externalUser") {
        if (
          externalDetail.filter((item: Member) => item.userId === value.value)
            .length > 0 &&
          [1, 3].includes(
            externalDetail.filter(
              (item: Member) => item.userId === value.value
            )[0].status
          )
        ) {
          const user = externalDetail.filter(
            (item: Member) => item.userId === value.value
          )[0];
          setExternalUserInfo({
            deptName: user.deptName,
            etc: user.etc,
            phoneNumber: user.phoneNumber,
            status: user.status,
            userId: user.userId,
            userName: user.userName,
            userType: user.userType,
          } as ExternalUser);
        } else {
          setExternalUserInfo({
            userId: value.value,
          } as ExternalUser);
        }
      } else {
        const resp: any = await getUserDetail(value.value);
        if (resp.payload) {
          setUserInfo(resp.payload as User);
        } else {
          setUserInfo({} as User);
        }
      }
      setUserDetail([] as User[]);
      setDeptDetail([] as DeptInfo[]);
    }

    // init
    setRightTab(0);
    checkboxGroupInternal.handleAllClick([]);
    checkboxGroupExternal.handleAllClick([]);
    checkboxGroupSearchInternal.handleAllClick([]);
    checkboxGroupSearchExternal.handleAllClick([]);
    checkboxGroupActiveInternal.handleAllClick([]);
    checkboxGroupActiveExternal.handleAllClick([]);

    setEditUserInfo({} as User);
    setIsNewPassword(false);
    setPassword({
      password1: "",
      password2: "",
      type: "RANDOM",
    });
  };

  const checkUserValid = async (user: User, type: "INSERT" | "UPDATE") => {
    if (
      (user.id === "" && user.id === undefined && user.id === null) ||
      !utilsCommon.userIdValidation(user.id)
    ) {
      toast.toastMsg(nanoid(), t("admin.dept.userIdError"), "error");
      return;
    }

    if (
      leftTab === 0 &&
      ((user.email === "" && user.email === undefined && user.email === null) ||
        !utilsCommon.emailValidation(user.email))
    ) {
      toast.toastMsg(nanoid(), t("admin.dept.emailCheck"), "error");
      return;
    }
    if (
      user.phoneNumber !== "" &&
      user.phoneNumber !== undefined &&
      user.phoneNumber !== null &&
      !utilsCommon.phoneNumberValidation(user.phoneNumber)
    ) {
      toast.toastMsg(nanoid(), t("admin.dept.phoneCheck"), "error");
      return;
    }

    if (type === "UPDATE" && leftTab === 0) {
      const result: any = await updateUserDept({
        id: editUserInfo.id,
        name: editUserInfo.name,
        email: editUserInfo.email,
        phoneNumber: editUserInfo.phoneNumber,
        position: editUserInfo.position,
        role: editUserInfo.role,
        depts: {
          primary: editUserInfo.dept,
          others: [],
        },
      } as UserDTO);

      if (result.payload) {
        toast.toastMsg(nanoid(), t("admin.common.alert.modify"), "success");
        setUserInfo(editUserInfo);
        if (targetData.state === "userUserUpdate") {
          setTargetData({
            ...targetData,
            type: "user",
            state: "view",
          });
        } else {
          setTargetData({
            ...targetData,
            type: "dept",
            state: "view",
          });
        }
      } else if (result.error.message) {
        toast.toastMsg(nanoid(), result.error.message, "error");
      } else {
        toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
      }
    }

    if (type === "UPDATE" && leftTab === 1) {
      const result: any = await updateExternalUserDept(editExternalUserInfo);
      if (result.payload) {
        toast.toastMsg(nanoid(), t("admin.common.alert.modify"), "success");
        setExternalUserInfo(editExternalUserInfo);
        if (targetData.state === "userUserUpdate") {
          setTargetData({
            ...targetData,
            type: "externalUser",
            state: "view",
          });
        } else {
          setTargetData({
            ...targetData,
            type: "dept",
            state: "view",
          });
        }
      } else if (result.error.message) {
        toast.toastMsg(nanoid(), result.error.message, "error");
      } else {
        toast.toastMsg(nanoid(), t("admin.ommon.alert.fail"), "error");
      }
    }

    if (type === "INSERT") {
      if (password.type !== "RANDOM") {
        if (password.password1 !== password.password2) {
          toast.toastMsg(nanoid(), t("admin.dept.passwordCheck"), "error");
          return;
        } else if (!utilsCommon.passwordValidation(password.password1)) {
          toast.toastMsg(nanoid(), t("admin.dept.passwordValidation"), "error");
          return;
        }
      }

      const result: any = await addUserDept({
        id: editUserInfo.id,
        name: editUserInfo.name,
        email: editUserInfo.email,
        phoneNumber: editUserInfo.phoneNumber,
        position: editUserInfo.position,
        role: editUserInfo.role,
        depts: {
          primary: editUserInfo.dept,
          others: [],
        },
        password: password.type === "RANDOM" ? "RANDOM" : password.password1,
      } as UserDTO);

      if (result.payload) {
        toast.toastMsg(nanoid(), t("admin.common.alert.add"), "success");

        const userResult: any = await getDeptUsers(editUserInfo.dept.code);
        if (userResult.payload) {
          setUserDetail(userResult.payload.resp as User[]);
        } else {
          setUserDetail(userDetail.concat(editUserInfo));
        }
        selectNode({
          value: editUserInfo.dept.code,
          columnText: editUserInfo.dept.name,
          type: "dept",
        });
      } else if (result.error.message) {
        toast.toastMsg(nanoid(), result.error.message, "error");
      } else {
        toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
      }
    }

    setPassword({
      password1: "",
      password2: "",
      type: "RANDOM",
    });
    setEditUserInfo({} as User);
  };

  const checkUserState = () => {
    if (
      targetData.state === "userUserUpdate" ||
      targetData.state === "deptUserUpdate"
    ) {
      return "UPDATE";
    } else if (targetData.state === "userInsert") {
      return "INSERT";
    } else if (
      targetData.type === "user" ||
      targetData.type === "externalUser"
    ) {
      return "VIEW";
    } else if (targetData.type === "external") {
      return "EXTERNAL";
    } else if (targetData.type === "internal_search") {
      return "INTERNAL_SEARCH";
    } else if (targetData.type === "external_search") {
      return "EXTERNAL_SEARCH";
    } else if (targetData.type === "internal_active") {
      return "INTERNAL_ACTIVE";
    } else if (targetData.type === "external_active") {
      return "EXTERNAL_ACTIVE";
    } else {
      return "DEPT";
    }
  };

  function findDeptNodes(trees: TreeNode[], targetId: string): TreeNode[] {
    function excludeSubTree(node: TreeNode): TreeNode | null {
      if (node.value === targetId) {
        return {
          ...node,
          showChildren: false,
          hasChildren: false,
          subTree: [],
        };
      }

      const filteredChildren = node.subTree
        .map(excludeSubTree)
        .filter((child): child is TreeNode => child !== null);

      if (node.type === "dept") {
        return {
          ...node,
          subTree: filteredChildren,
        };
      }
      return null;
    }
    const result: TreeNode[] = [];

    for (const root of trees) {
      const filteredRoot = excludeSubTree(root);
      if (filteredRoot) {
        result.push(filteredRoot);
      }
    }

    return result;
  }

  const changePassword = async () => {
    if (password.type === "") {
      if (password.password1 !== password.password2) {
        toast.toastMsg(nanoid(), t("common.alert.passwordCheck"), "error");

        return;
      } else if (!utilsCommon.passwordValidation(password.password1)) {
        toast.toastMsg(nanoid(), t("common.alert.passwordValidation"), "error");
        return;
      }
      const user: UserPasswd = {
        userId:
          leftTab === 0
            ? ["VIEW"].includes(checkUserState())
              ? userInfo.id
              : editUserInfo.id
            : ["VIEW"].includes(checkUserState())
            ? externalUserInfo.userId
            : editExternalUserInfo.userId,
        password: password.password1,
      };
      const result: any = await userPasswdUpdate(user);
      if (result.payload) {
        toast.toastMsg(
          nanoid(),
          t("admin.dept.changePasswordComplete"),
          "success"
        );
        setIsNewPassword(false);
        setPassword({
          password1: "",
          password2: "",
          type: "RANDOM",
        });
      } else if (result.error.message) {
        toast.toastMsg(nanoid(), result.error.message, "error");
      } else {
        toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
      }
    } else if (password.type === "RANDOM") {
      const result: any = await userPasswdInit(
        leftTab === 0
          ? ["VIEW"].includes(checkUserState())
            ? userInfo.id
            : editUserInfo.id
          : ["VIEW"].includes(checkUserState())
          ? externalUserInfo.userId
          : editExternalUserInfo.userId
      );
      if (result.payload) {
        toast.toastMsg(nanoid(), t("admin.dept.sendEmailMessage"), "success");
        setIsNewPassword(false);
        setPassword({
          password1: "",
          password2: "",
          type: "RANDOM",
        });
      } else if (result.error.message) {
        toast.toastMsg(nanoid(), result.error.message, "error");
      } else {
        toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
      }
    }
  };

  const handleChooseFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      let tempUser: AddDepartment[] = [];
      setFileSelected(files[0]);
      if (files[0].size === 0) {
        alert(t("admin.common.alert.noData"));
      } else {
        readXlsxFile(files[0], { sheet: 1 })
          .then((rows: any) => {
            if (rows) {
              for (var index = 0; index < rows.length; index++) {
                if (index > 0) {
                  tempUser.push({
                    id: rows[index][0]?.toString(),
                    name: rows[index][1]?.toString(),
                    email: rows[index][2]?.toString(),
                    dept: {
                      code: rows[index][3]?.toString(),
                      name: rows[index][4]?.toString(),
                    },
                    position: {
                      code: rows[index][5]?.toString(),
                      name: rows[index][6]?.toString(),
                    },
                    role: { name: "General" },
                    phoneNumber: rows[index][7]?.toString(),
                  });
                }
              }
            }

            setSelectedDeptList(tempUser);
            toggleExcelModal(true);
          })
          .catch((err: any) => alert(err));
      }
    }
    e.target.value = "";
  };

  function transformInternalUserList(data: any, check: any) {
    const dataTransformed = [] as ColumnDatas[];
    data &&
      data.length > 0 &&
      data.map((user: any) => {
        const dataItemTransformed = {
          data: [
            {
              columnText: (
                <Box alignItems="center">
                  <Avatar
                    uniqueCode={utilsCommon.getUserColor(1)}
                    name={user.name}
                    classes="avatarManager mg mr-8 "
                    subLeftIcon={
                      user.id === user?.dept?.managerId ? (
                        <WorkgroupManagerIcon
                          style={{
                            position: "absolute",
                            bottom: "-5px",
                            insetInlineEnd: "-12px",
                          }}
                        />
                      ) : undefined
                    }
                  />
                  {utilsCommon.getNameWithId(user.name, user.id)}
                </Box>
              ),
            },
            {
              columnText: user.dept?.name
                ? user.dept?.name
                : user.depts?.primary?.name
                ? user.depts?.primary?.name
                : "",
            },
            {
              columnText: user.role.name,
            },
            {
              columnText: user.position.name,
            },
            {
              columnText: user.email,
            },
            {
              columnText: user.phoneNumber,
            },
            {
              columnText:
                targetData.state === "deptManagerUpdate" ? (
                  user.id !== user.dept.managerId ? (
                    <Button
                      label={t("admin.dept.select")}
                      btnStyle="line"
                      size="sm"
                      onClick={() => {
                        setChangeManager(user);
                      }}
                    />
                  ) : (
                    ""
                  )
                ) : (
                  <Button
                    label={t("admin.dept.modify")}
                    btnStyle="line"
                    size="sm"
                    onClick={() => {
                      setEditUserInfo(user);
                      setTargetData({
                        ...targetData,
                        type: "user",
                        state: "deptUserUpdate",
                      });
                    }}
                  />
                ),
            },
          ],
          id: user.id,
          checkBoxClick:
            targetData.state === "deptManagerUpdate"
              ? undefined
              : () => {
                  checkboxGroupInternal.handleClick(user.id);
                },
        };
        dataTransformed.push(dataItemTransformed);
      });
    return dataTransformed;
  }

  function transformExternalUserList(data: Member[] | undefined, check: any) {
    const dataTransformed = [] as ColumnDatas[];
    data &&
      data.length > 0 &&
      data.map((user: Member) => {
        const dataItemTransformed = {
          data: [
            {
              columnText: (
                <Box alignItems="center">
                  <Avatar
                    uniqueCode={utilsCommon.getUserColor(2)}
                    name={user.userId}
                    classes="mg mr-8"
                  />
                  <Tooltip message={user.userId}>
                    <Typography ellipsis>{user.userId}</Typography>
                  </Tooltip>
                </Box>
              ),
            },
            {
              columnText: user.userName,
            },
            {
              columnText: user.companyName,
            },
            {
              columnText: user.phoneNumber,
            },
            {
              columnText: utilsCommon.changeStatusCodeToStringForInfo(
                user.status
              ),
            },
            {
              columnText:
                user.status === 1 || user.status === 3 ? (
                  <Button
                    label={t("admin.dept.modify")}
                    btnStyle="line"
                    size="sm"
                    onClick={() => {
                      setEditExternalUserInfo({
                        deptName: user.deptName,
                        etc: user.etc,
                        phoneNumber: user.phoneNumber,
                        status: user.status,
                        userId: user.userId,
                        userName: user.userName,
                        userType: user.userType,
                      } as ExternalUser);
                      setTargetData({
                        ...targetData,
                        type: "externalUser",
                        state: "deptUserUpdate",
                      });
                    }}
                  />
                ) : (
                  ""
                ),
            },
          ],
          id: user.userId,
          checkBoxClick: () => {
            check.handleClick(user.userId);
          },
        };
        dataTransformed.push(dataItemTransformed);
      });
    return dataTransformed;
  }

  function transformActiveUserList(data: ActiveUser[], check: any) {
    const dataTransformed = [] as ColumnDatas[];
    data &&
      data.length > 0 &&
      data.map((user: ActiveUser) => {
        const dataItemTransformed = {
          data: [
            {
              columnText: (
                <Box alignItems="center">
                  <Avatar
                    uniqueCode={utilsCommon.getUserColor(leftTab === 0 ? 1 : 2)}
                    name={user.userId}
                    classes="mg mr-8"
                  />
                  <Tooltip message={user.userId}>
                    <Typography ellipsis>{user.userId}</Typography>
                  </Tooltip>
                </Box>
              ),
            },
            {
              columnText: user.userName,
            },
            {
              columnText: utilsCommon.renderDateFormat(
                user.updatedTime === 0 ? user.registedTime : user.updatedTime
              ),
            },
          ],
          id: user.userId,
          checkBoxClick: () => {
            check.handleClick(user.userId);
          },
        };
        dataTransformed.push(dataItemTransformed);
      });
    return dataTransformed;
  }

  function transformDeptList(data: DeptInfo[] | undefined) {
    const dataTransformed = [] as ColumnDatas[];
    data &&
      data.length > 0 &&
      data.map((dept: DeptInfo) => {
        const dataItemTransformed = {
          data: [
            {
              columnText: "",
            },
            {
              columnText: (
                <Box alignItems="center">
                  <Avatar
                    uniqueCode={dept.code}
                    name={dept.name}
                    classes="mg mr-8"
                    shape="workgroup"
                  />
                  {dept.name}
                </Box>
              ),
            },
            {
              columnText: dept.managerId
                ? utilsCommon.getNameWithId(dept.managerName, dept.managerId)
                : t("admin.dept.unspecified"),
            },
            {
              columnText: dept.deptCount,
            },
            {
              columnText: dept.userCount,
            },
          ],
          id: dept.code,
        };
        dataTransformed.push(dataItemTransformed);
      });
    return dataTransformed;
  }

  return (
    <Box classes="adminDept" direction="column">
      <Box classes="adminDept-title" justifyContent="space-between">
        <Typography type="h1">{t("admin.menu.dept")}</Typography>
      </Box>
      {showExcelModal && (
        <AddExcelGroupModal
          showExcelModal={showExcelModal}
          toggleExcelModal={toggleExcelModal}
          selectedDeptList={selectedDeptList}
          deptState={adminDeptStore.deptList}
          positionState={positionRoleState.positionList}
          fileSelected={fileSelected}
        />
      )}
      {((updateDeptInfo?.code && updateDeptInfo?.code !== "") ||
        (insertDeptInfo?.code && insertDeptInfo?.code !== "")) && (
        <Modal
          width={490}
          footer={
            <Box justifyContent="flex-end">
              <Button
                label={t("admin.common.button.cancel")}
                type="secondary"
                btnStyle="fill"
                onClick={() => {
                  setInsertDeptInfo({} as DeptInfo);
                  setUpdateDeptInfo({} as DeptInfo);
                }}
              />
              {updateDeptInfo?.code && updateDeptInfo?.code !== "" ? (
                <Button
                  label={t("admin.common.button.modify")}
                  type="primary"
                  btnStyle="fill"
                  onClick={async () => {
                    const param = {
                      code: updateDeptInfo?.code,
                      name: updateDeptInfo?.name,
                    } as ChangeDeptNameParam;

                    const result: any = await changeDeptName(param);
                    if (result.payload) {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.modify"),
                        "success"
                      );
                      setTargetData({
                        ...targetData,
                        name: updateDeptInfo?.name,
                      });
                      setUpdateDeptInfo({} as DeptInfo);
                    } else if (result.error.message) {
                      toast.toastMsg(nanoid(), result.error.message, "error");
                    } else {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.fail"),
                        "error"
                      );
                    }
                  }}
                />
              ) : (
                <Button
                  label={t("admin.common.button.add")}
                  type="primary"
                  btnStyle="fill"
                  onClick={async () => {
                    let param = {
                      managerId: "",
                      name: insertDeptInfo.managerName,
                      parentCode: insertDeptInfo.code,
                    } as AddDeptParam;

                    const result: any = await addDept(param);
                    if (result.payload) {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.add"),
                        "success"
                      );
                      selectNode({
                        value: insertDeptInfo.code,
                        columnText: insertDeptInfo.name,
                        type: "dept",
                      });
                      setInsertDeptInfo({} as DeptInfo);
                    } else if (result.error.message) {
                      toast.toastMsg(nanoid(), result.error.message, "error");
                    } else {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.fail"),
                        "error"
                      );
                    }
                  }}
                />
              )}
            </Box>
          }
          title={
            updateDeptInfo?.code && updateDeptInfo?.code !== ""
              ? t("admin.dept.changeDeptName")
              : t("admin.dept.addSubDept")
          }
          subTitle={
            updateDeptInfo?.code && updateDeptInfo?.code !== ""
              ? t("admin.dept.changeSelectedDeptName", {
                  dept: updateDeptInfo?.name + "",
                })
              : t("admin.dept.deptSubtitle", {
                  dept: insertDeptInfo?.name + "",
                })
          }
          open={updateDeptInfo?.code !== "" || insertDeptInfo?.code !== ""}
          onClose={() => {
            setInsertDeptInfo({} as DeptInfo);
            setUpdateDeptInfo({} as DeptInfo);
          }}
          body={
            updateDeptInfo?.code && updateDeptInfo?.code !== "" ? (
              <Box direction="column">
                <Typography
                  classes="mg mb-8"
                  type="body4_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.deptName")}
                </Typography>
                <InputField
                  value={updateDeptInfo.name}
                  placeholder={t("admin.dept.insertDeptName")}
                  width={432}
                  onChange={(e) => {
                    setUpdateDeptInfo({
                      ...updateDeptInfo,
                      name: e.target.value,
                    });
                  }}
                />
              </Box>
            ) : (
              <Box direction="column">
                <Typography
                  classes="mg mb-8"
                  type="body4_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.deptName")}
                </Typography>
                <InputField
                  value={insertDeptInfo.managerName}
                  placeholder={t("admin.dept.insertDeptName")}
                  width={432}
                  onChange={(e) => {
                    // managerName을 이용해서 부서 이름으로 사용
                    setInsertDeptInfo({
                      ...insertDeptInfo,
                      managerName: e.target.value,
                    });
                  }}
                />
              </Box>
            )
          }
        />
      )}
      {(deleteUserInfo.length > 0 || deleteDeptInfo?.code) && (
        <DeleteUserOrDept
          onClose={() => {
            setDeleteUserInfo([] as User[]);
            setDeleteDeptInfo({} as DeptInfo);
          }}
          onDelete={async () => {
            if (deleteUserInfo.length > 0) {
              let param = [] as { id: string }[];
              deleteUserInfo.map((user) => {
                param.push({
                  id: user.id,
                });
              });
              const result: any = await deleteUser(param);

              if (result.payload) {
                toast.toastMsg(
                  nanoid(),
                  t("admin.common.alert.delete"),
                  "success"
                );

                setDeleteUserInfo([] as User[]);
                checkboxGroupInternal.handleAllClick([]);
                checkboxGroupExternal.handleAllClick([]);
                if (leftTab === 0) {
                  if (userStatus === "ALL") {
                    selectNode({
                      value: deleteUserInfo[0].dept.code,
                      columnText: deleteUserInfo[0].dept.name,
                      type: "dept",
                    });
                  } else {
                    selectNode({
                      value: "INTERNAL_ACTIVE",
                      columnText: t("admin.dept.internalUser"),
                      type: "company",
                    });
                  }
                } else {
                  if (userStatus === "ALL") {
                    selectNode({
                      value: "EXTERNAL",
                      columnText: t("admin.dept.externalUser"),
                      type: "company",
                    });
                  } else {
                    selectNode({
                      value: "EXTERNAL_ACTIVE",
                      columnText: t("admin.dept.externalUser"),
                      type: "company",
                    });
                  }
                }
              } else if (result.error.message) {
                toast.toastMsg(nanoid(), result.error.message, "error");
              } else {
                toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
              }
            } else if (deleteDeptInfo?.code !== "") {
              const result: any = await deleteDept(deleteDeptInfo?.code);

              if (result.payload) {
                toast.toastMsg(
                  nanoid(),
                  t("admin.common.alert.delete"),
                  "success"
                );
                selectNode({
                  value: ROOT_DEPT_CODE,
                  columnText: companyName,
                  type: "company",
                });
                setDeleteDeptInfo({} as DeptInfo);
              } else if (result.error.message) {
                toast.toastMsg(nanoid(), result.error.message, "error");
              } else {
                toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
              }
            }
          }}
          deleteUserInfo={deleteUserInfo}
          deleteDeptInfo={deleteDeptInfo}
        />
      )}
      {(moveUserInfo.length > 0 || moveDeptInfo?.code) && (
        <Modal
          width={490}
          height={600}
          footer={
            <Box justifyContent="flex-end">
              <Button
                label={t("admin.common.button.cancel")}
                type="secondary"
                btnStyle="fill"
                onClick={() => {
                  setMoveTargetCode("");
                  setMoveTargetName("");
                  setExpandModalValues([ROOT_DEPT_CODE]);
                  setMoveUserInfo([] as User[]);
                  setMoveDeptInfo({} as DeptInfo);
                }}
              />
              <Button
                label={t("admin.common.button.apply")}
                type="primary"
                btnStyle="fill"
                state={moveTargetCode === "" ? "disable" : "default"}
                onClick={async () => {
                  if (moveUserInfo.length > 0) {
                    let param = [] as UserDTO[];
                    let results = 0;
                    moveUserInfo.map((user) =>
                      param.push({
                        id: user.id,
                        name: user.name,
                        email: user.email,
                        phoneNumber: user.phoneNumber,
                        position: {
                          code: user.position.code,
                          name: user.position.name,
                        },
                        role: {
                          code: user.role.code,
                          name: user.role.name,
                        },
                        depts: {
                          primary: {
                            code: moveTargetCode,
                            name: moveTargetName,
                          },
                          others: [],
                        },
                      })
                    );

                    for (let i = 0; i < param.length; i++) {
                      let result: any = await updateUserDept(param[i]);
                      if (result.payload) results++;
                      else if (result.error.message) {
                        toast.toastMsg(nanoid(), result.error.message, "error");
                        break;
                      } else {
                        toast.toastMsg(
                          nanoid(),
                          t("admin.common.alert.fail"),
                          "error"
                        );
                        break;
                      }
                    }

                    if (results === param.length) {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.modify"),
                        "success"
                      );
                    } else {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.fail"),
                        "error"
                      );
                    }
                    setMoveTargetCode("");
                    setMoveTargetName("");
                    setExpandModalValues([ROOT_DEPT_CODE]);
                    setMoveUserInfo([] as User[]);
                    setMoveDeptInfo({} as DeptInfo);
                    selectNode({
                      value: targetData.id,
                      columnText: targetData.name,
                      type: "dept",
                    });
                  } else if (moveDeptInfo?.code !== "") {
                    const param = {
                      code: moveDeptInfo.code,
                      parentCode: moveTargetCode,
                    };

                    const result: any = await updateDeptParent(param);
                    if (result.payload) {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.modify"),
                        "success"
                      );
                    } else if (result.error.message) {
                      toast.toastMsg(nanoid(), result.error.message, "error");
                    } else {
                      toast.toastMsg(
                        nanoid(),
                        t("admin.common.alert.fail"),
                        "error"
                      );
                    }
                    setMoveTargetCode("");
                    setMoveTargetName("");
                    setExpandModalValues([ROOT_DEPT_CODE]);
                    setMoveUserInfo([] as User[]);
                    setMoveDeptInfo({} as DeptInfo);
                  }
                }}
              />
            </Box>
          }
          title={
            moveUserInfo.length > 0
              ? t("admin.dept.transferUserDept")
              : t("admin.dept.transferDept")
          }
          open={moveUserInfo.length > 0 || moveDeptInfo?.code !== ""}
          onClose={() => {
            setMoveTargetCode("");
            setMoveTargetName("");
            setExpandModalValues([ROOT_DEPT_CODE]);
            setMoveUserInfo([] as User[]);
            setMoveDeptInfo({} as DeptInfo);
          }}
          body={
            <Box maxHeight={426}>
              <Tree
                width="100%"
                treeData={{
                  columnText: companyName,
                  subTree: findDeptNodes(
                    [...adminDeptStore.internalTree.subTree],
                    moveUserInfo.length > 0 ? "" : targetData.id
                  ),
                  showChildren: true,
                  hasChildren: true,
                  value: ROOT_DEPT_CODE,
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandModalValues.includes(value)) {
                    setExpandModalValues(
                      expandModalValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandModalValues([...expandValues, value]);
                    searchTree(value);
                  }
                }}
                depth={0}
                checkType="radio"
                treeType="eco"
                checkValues={[moveTargetCode]}
                checkAction={(value: any) => {
                  setMoveTargetCode(value.value);
                  setMoveTargetName(value.columnText);
                }}
                selectNode={() => {}}
                expandValues={expandModalValues}
                expandSearchValues={[moveTargetCode]}
                disableValues={moveUserInfo.length > 0 ? [] : [targetData.id]}
              />
            </Box>
          }
        />
      )}
      <Box direction="row" classes="adminDept-body">
        <Box direction="column" classes="adminDept-body-tree">
          <Box classes="adminDept-body-tab">
            <Tabs
              tabs={[
                {
                  color: "default",
                  isNew: false,
                  text: t("admin.dept.internalUser"),
                },
                {
                  color: "default",
                  isNew: false,
                  text: t("admin.dept.externalUser"),
                },
              ]}
              selectTab={(value) => {
                setLeftTab(value);
              }}
              selected={leftTab}
              size={"md"}
              type="full"
              textAlign="center"
            />
          </Box>
          <Box direction="column">
            <Box direction="row" classes="mg mt-12">
              <InputField
                placeholder={t("admin.dept.searchInput")}
                size="sm"
                width={291}
                value={tempSearchWord}
                onChange={(e) => {
                  setTempSearchWord(e.target.value);
                }}
                onKeyUp={(e) => {
                  if (e.code === "Enter") {
                    doSearchWord();
                  }
                }}
              />
            </Box>
            <Box classes="mg mt-8">
              <Dropdown
                btnSize="sm"
                placeholder=" "
                value={
                  userStatus === "ACTIVE"
                    ? t("admin.dept.loginUser")
                    : t("admin.dept.allUser")
                }
                width={214}
                buttonClick={buttonClick}
                disabled={searchWord !== ""}
              >
                <DropdownItem
                  label={t("admin.dept.allUser")}
                  onClick={() => {
                    setUserStatus("ALL");
                    changeButtonClick(buttonClick + 1);
                    if (leftTab === 0) {
                      selectNode({
                        value: ROOT_DEPT_CODE,
                        columnText: companyName,
                        type: "company",
                      });
                      setExpandValues([ROOT_DEPT_CODE]);
                    } else if (leftTab === 1) {
                      selectNode({
                        value: "EXTERNAL",
                        columnText: t("admin.dept.externalUser"),
                        type: "company",
                      });
                      setExpandValues(["EXTERNAL"]);
                    }
                  }}
                />
                <DropdownItem
                  label={t("admin.dept.loginUser")}
                  onClick={() => {
                    setUserStatus("ACTIVE");
                    changeButtonClick(buttonClick + 1);
                    if (leftTab === 0) {
                      selectNode({
                        value: "INTERNAL_ACTIVE",
                        columnText: t("admin.dept.internalUser"),
                        type: "internal_active",
                      });
                      setExpandValues(["INTERNAL_ACTIVE"]);
                    } else if (leftTab === 1) {
                      selectNode({
                        value: "EXTERNAL_ACTIVE",
                        columnText: t("admin.dept.externalUser"),
                        type: "external_active",
                      });
                      setExpandValues(["EXTERNAL_ACTIVE"]);
                    }
                  }}
                />
              </Dropdown>
              <Button
                label={t("admin.common.button.search")}
                size="sm"
                width={68}
                type="primary"
                btnStyle="fill"
                classes="mg ml-8"
                onClick={() => {
                  doSearchWord();
                }}
              />
            </Box>
          </Box>
          {leftTab === 0 && userStatus === "ALL" && searchWord === "" && (
            <Box classes="adminDept-body-tree-dept">
              <Tree
                width="100%"
                treeData={{
                  columnText: companyName,
                  subTree: [...adminDeptStore.internalTree.subTree],
                  showChildren: true,
                  hasChildren: true,
                  value: ROOT_DEPT_CODE,
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandValues.includes(value)) {
                    setExpandValues(
                      expandValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandValues([...expandValues, value]);
                    searchTree(value);
                  }
                }}
                depth={0}
                checkType="none"
                treeType="eco"
                checkValues={[targetData.id]}
                checkAction={() => {}}
                selectNode={(value: any) => {
                  selectNode(value);
                }}
                expandValues={expandValues}
                expandSearchValues={[targetData.id]}
              />
            </Box>
          )}
          {leftTab === 0 && userStatus === "ACTIVE" && searchWord === "" && (
            <Box classes="adminDept-body-tree-dept">
              <Tree
                width="100%"
                treeData={{
                  columnText: t("admin.dept.internalUser"),
                  subTree: [...adminDeptStore.internalActiveTree.subTree],
                  showChildren: true,
                  hasChildren: true,
                  value: "INTERNAL_ACTIVE",
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandValues.includes(value)) {
                    setExpandValues(
                      expandValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandValues([...expandValues, value]);
                  }
                }}
                depth={0}
                checkType="none"
                treeType="eco"
                checkValues={[targetData.id]}
                checkAction={() => {}}
                selectNode={(value: any) => {
                  selectNode(value);
                }}
                expandValues={expandValues}
                expandSearchValues={[targetData.id]}
              />
            </Box>
          )}
          {leftTab === 0 && searchWord !== "" && (
            <Box classes="adminDept-body-tree-dept">
              <Tree
                width="100%"
                treeData={{
                  columnText: t("admin.dept.internalUser"),
                  subTree: [...adminDeptStore.internalSearchTree.subTree],
                  showChildren: true,
                  hasChildren: true,
                  value: searchWord,
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandValues.includes(value)) {
                    setExpandValues(
                      expandValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandValues([...expandValues, value]);
                  }
                }}
                depth={0}
                checkType="none"
                treeType="eco"
                checkValues={[targetData.id]}
                checkAction={() => {}}
                selectNode={(value: any) => {
                  selectNode(value);
                }}
                expandValues={expandValues}
                expandSearchValues={[targetData.id]}
              />
            </Box>
          )}
          {leftTab === 1 && userStatus === "ALL" && searchWord === "" && (
            <Box classes="adminDept-body-tree-dept">
              <Tree
                width="100%"
                treeData={{
                  columnText: t("admin.dept.externalUser"),
                  subTree: [...adminDeptStore.externalTree.subTree],
                  showChildren: true,
                  hasChildren: true,
                  value: "EXTERNAL",
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandValues.includes(value)) {
                    setExpandValues(
                      expandValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandValues([...expandValues, value]);
                  }
                }}
                depth={0}
                checkType="none"
                treeType="eco"
                checkValues={[targetData.id]}
                checkAction={() => {}}
                selectNode={(value: any) => {
                  selectNode(value);
                }}
                expandValues={expandValues}
                expandSearchValues={[targetData.id]}
              />
            </Box>
          )}
          {leftTab === 1 && userStatus === "ACTIVE" && searchWord === "" && (
            <Box classes="adminDept-body-tree-dept">
              <Tree
                width="100%"
                treeData={{
                  columnText: t("admin.dept.externalUser"),
                  subTree: [...adminDeptStore.externalActiveTree.subTree],
                  showChildren: true,
                  hasChildren: true,
                  value: "EXTERNAL_ACTIVE",
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandValues.includes(value)) {
                    setExpandValues(
                      expandValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandValues([...expandValues, value]);
                  }
                }}
                depth={0}
                checkType="none"
                treeType="eco"
                checkValues={[targetData.id]}
                checkAction={() => {}}
                selectNode={(value: any) => {
                  selectNode(value);
                }}
                expandValues={expandValues}
                expandSearchValues={[targetData.id]}
              />
            </Box>
          )}
          {leftTab === 1 && searchWord !== "" && (
            <Box classes="adminDept-body-tree-dept">
              <Tree
                width="100%"
                treeData={{
                  columnText: t("admin.dept.externalUser"),
                  subTree: [...adminDeptStore.externalSearchTree.subTree],
                  showChildren: true,
                  hasChildren: true,
                  value: searchWord,
                  type: "company",
                }}
                expandAction={(value: string) => {
                  if (expandValues.includes(value)) {
                    setExpandValues(
                      expandValues.filter((item) => item !== value)
                    );
                  } else {
                    setExpandValues([...expandValues, value]);
                  }
                }}
                depth={0}
                checkType="none"
                treeType="eco"
                checkValues={[targetData.id]}
                checkAction={() => {}}
                selectNode={(value: any) => {
                  selectNode(value);
                }}
                expandValues={expandValues}
                expandSearchValues={[targetData.id]}
              />
            </Box>
          )}
        </Box>
        <Box
          ref={tableRef}
          direction="column"
          classes="adminDept-body-contents"
        >
          <Box
            classes="adminDept-body-contents-title"
            justifyContent="space-between"
          >
            <Box alignItems="center">
              <Typography>{targetData.name}</Typography>
              {targetData.type === "dept" &&
                targetData.id !== ROOT_DEPT_CODE && (
                  <Button
                    btnStyle="icon"
                    leadingIcon={<Icons variant="line" label="edit2" />}
                    classes="mg ml-8"
                    onClick={() => {
                      setUpdateDeptInfo({
                        code: targetData.id,
                        name: targetData.name,
                      } as DeptInfo);
                    }}
                  />
                )}
            </Box>
            {targetData.type === "dept" &&
              !editUserInfo.dept &&
              targetData.state !== "deptManagerUpdate" && (
                <Box>
                  <Button
                    label={t("admin.common.button.move")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      targetData.id === ROOT_DEPT_CODE ? "disable" : "default"
                    }
                    onClick={() => {
                      setMoveTargetCode("");
                      setMoveTargetName("");
                      setExpandModalValues([ROOT_DEPT_CODE]);
                      setMoveDeptInfo({
                        code: targetData.id,
                        name: targetData.name,
                      } as DeptInfo);
                    }}
                  />
                  <Button
                    label={t("admin.common.button.delete")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      targetData.id === ROOT_DEPT_CODE ||
                      (userDetail && userDetail.length > 0) ||
                      (deptDetail && deptDetail.length > 0)
                        ? "disable"
                        : "default"
                    }
                    onClick={() => {
                      setDeleteDeptInfo({
                        code: targetData.id,
                        name: targetData.name,
                      } as DeptInfo);
                    }}
                  />
                  <Button
                    label={t("admin.common.button.add")}
                    size="sm"
                    btnStyle="fill"
                    type="primary"
                    onClick={() => {
                      setInsertDeptInfo({
                        code: targetData.id,
                        name: targetData.name,
                      } as DeptInfo);
                    }}
                  />
                  <input
                    style={{ display: "none" }}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    id="excelFile"
                    name="excelFile"
                    type="file"
                    ref={inputFile}
                    multiple={false}
                    onChange={(e) => {
                      handleChooseFile(e);
                    }}
                  />
                  <label htmlFor="excelFile">
                    <Button
                      label={t("admin.dept.uploadDept")}
                      size="sm"
                      btnStyle="line"
                    />
                  </label>
                  <Button
                    label={t("admin.dept.downloadDept")}
                    size="sm"
                    btnStyle="line"
                    onClick={() => {
                      downloadDeptFile();
                    }}
                  />
                </Box>
              )}
            {checkUserState() === "VIEW" && (
              <Box>
                {leftTab === 0 && (
                  <Button
                    label={t("admin.common.button.move")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    onClick={() => {
                      setMoveTargetCode("");
                      setMoveTargetName("");
                      setExpandModalValues([ROOT_DEPT_CODE]);
                      setMoveUserInfo([userInfo]);
                    }}
                  />
                )}
                <Button
                  label={t("admin.common.button.delete")}
                  size="sm"
                  btnStyle="fill"
                  type="secondary"
                  onClick={() => {
                    if (leftTab === 0) {
                      setDeleteUserInfo([userInfo]);
                    } else if (leftTab === 1) {
                      setDeleteUserInfo([
                        { id: externalUserInfo.userId } as User,
                      ]);
                    }
                  }}
                />
                <Button
                  label={t("admin.common.button.modify")}
                  size="sm"
                  btnStyle="fill"
                  type="primary"
                  onClick={() => {
                    if (leftTab === 0) {
                      setEditUserInfo(userInfo);
                    } else if (leftTab === 1) {
                      setEditExternalUserInfo(externalUserInfo);
                    }
                    setTargetData({ ...targetData, state: "userUserUpdate" });
                  }}
                  state={
                    leftTab === 0
                      ? "default"
                      : externalDetail.filter(
                          (item: Member) =>
                            item.userId === externalUserInfo.userId
                        ).length > 0 &&
                        [1, 3].includes(
                          externalDetail.filter(
                            (item: Member) =>
                              item.userId === externalUserInfo.userId
                          )[0].status
                        )
                      ? "default"
                      : "disable"
                  }
                />
              </Box>
            )}
            {["UPDATE", "INSERT"].includes(checkUserState()) && (
              <Box>
                <Button
                  label={t("admin.common.button.cancel")}
                  size="sm"
                  btnStyle="fill"
                  type="secondary"
                  onClick={() => {
                    setEditUserInfo({} as User);
                    if (targetData.state === "userUserUpdate") {
                      setTargetData({
                        ...targetData,
                        type: leftTab === 0 ? "user" : "externalUser",
                        state: "view",
                      });
                    } else {
                      setTargetData({
                        ...targetData,
                        type: leftTab === 0 ? "dept" : "external",
                        state: "view",
                      });
                    }
                  }}
                />
                <Button
                  label={t("admin.common.button.apply")}
                  size="sm"
                  btnStyle="fill"
                  type="primary"
                  onClick={() => {
                    if (checkUserState() === "UPDATE") {
                      checkUserValid(editUserInfo, "UPDATE");
                    }
                    if (checkUserState() === "INSERT") {
                      checkUserValid(editUserInfo, "INSERT");
                    }
                  }}
                />
              </Box>
            )}
          </Box>
          {checkUserState() === "DEPT" && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Box classes="adminDept-body-contents-body-manager">
                <Typography exactColor={getColor("COLOR_TEXT_SECONDARY")}>
                  {t("admin.dept.headDept")}
                </Typography>
                {changeManager.id ? (
                  <>
                    <Avatar
                      uniqueCode={utilsCommon.getUserColor(1)}
                      name={changeManager.name}
                    />
                    <Typography>
                      {utilsCommon.getNameWithId(
                        changeManager.name,
                        changeManager.id
                      )}
                    </Typography>
                  </>
                ) : userDetail &&
                  userDetail.length > 0 &&
                  userDetail[0]?.dept?.managerId ? (
                  <>
                    <Avatar
                      uniqueCode={utilsCommon.getUserColor(1)}
                      name={getDeptManagerName()}
                    />
                    <Typography>
                      {userDetail.length > 0 &&
                        userDetail[0].dept.managerId &&
                        utilsCommon.getNameWithId(
                          getDeptManagerName(),
                          userDetail[0].dept.managerId
                        )}
                    </Typography>
                  </>
                ) : (
                  ""
                )}
                {targetData.state !== "deptManagerUpdate" &&
                  userDetail &&
                  userDetail.length > 0 &&
                  !(
                    userDetail.length === 1 &&
                    userDetail[0]?.id === userDetail[0]?.dept?.managerId
                  ) && (
                    <Button
                      label={t("admin.common.button.change")}
                      size="sm"
                      btnStyle="round"
                      onClick={() => {
                        setChangeManager({} as User);
                        setTargetData({
                          ...targetData,
                          state: "deptManagerUpdate",
                        });
                        setRightTab(0);
                      }}
                    />
                  )}
                {targetData.state === "deptManagerUpdate" && (
                  <Box>
                    <Button
                      label={t("admin.common.button.cancel")}
                      size="sm"
                      btnStyle="round"
                      onClick={() => {
                        setChangeManager({} as User);
                        setTargetData({
                          ...targetData,
                          state: "view",
                        });
                      }}
                    />
                    <Button
                      label={t("admin.common.button.apply")}
                      size="sm"
                      btnStyle="fill"
                      classes="mg ml-8"
                      onClick={async () => {
                        let param = {
                          code: changeManager.dept.code,
                          managerId: changeManager.id,
                        } as DeptManagerParam;
                        const result: any = await updateDeptManager(param);

                        if (result.payload) {
                          toast.toastMsg(
                            nanoid(),
                            t("admin.common.alert.modify"),
                            "success"
                          );
                          selectNode({
                            value: changeManager.dept.code,
                            columnText: changeManager.dept.name,
                            type: "dept",
                          });
                          setChangeManager({} as User);
                          setTargetData({
                            ...targetData,
                            state: "view",
                          });
                        } else if (result.error.message) {
                          toast.toastMsg(
                            nanoid(),
                            result.error.message,
                            "error"
                          );
                        } else {
                          toast.toastMsg(
                            nanoid(),
                            t("admin.common.alert.fail"),
                            "error"
                          );
                        }
                      }}
                      state={changeManager.id ? "default" : "disable"}
                    />
                  </Box>
                )}
              </Box>
              <Tabs
                tabs={[
                  {
                    color: "default",
                    isNew: false,
                    text: t("admin.dept.user"),
                  },
                  {
                    color: "default",
                    isNew: false,
                    text: t("admin.dept.dept"),
                  },
                ]}
                selectTab={(value) => {
                  targetData.state !== "deptManagerUpdate" &&
                    setRightTab(value);
                }}
                selected={rightTab}
                size={"md"}
                type="full"
                textAlign="center"
                classes="mg mt-12"
              />
              {rightTab === 0 && (
                <Box direction="column">
                  <Box classes="adminDept-body-contents-body-userList">
                    <Typography
                      type="body2_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.dept.memberTotal", {
                        count:
                          userDetail && userDetail.length > 0
                            ? userDetail.length
                            : 0,
                      })}
                    </Typography>
                    {targetData.state !== "deptManagerUpdate" && (
                      <Box>
                        <Button
                          label={t("admin.common.button.move")}
                          size="sm"
                          btnStyle="fill"
                          type="secondary"
                          state={
                            checkboxGroupInternal.selected.length === 0
                              ? "disable"
                              : "default"
                          }
                          onClick={() => {
                            setMoveTargetCode("");
                            setMoveTargetName("");
                            setExpandModalValues([ROOT_DEPT_CODE]);
                            setMoveUserInfo(
                              userDetail.filter((item) =>
                                checkboxGroupInternal.selected.includes(item.id)
                              )
                            );
                          }}
                        />
                        <Button
                          label={t("admin.common.button.delete")}
                          size="sm"
                          btnStyle="fill"
                          type="secondary"
                          state={
                            checkboxGroupInternal.selected.length === 0
                              ? "disable"
                              : "default"
                          }
                          onClick={() => {
                            setDeleteUserInfo(
                              userDetail.filter((item) =>
                                checkboxGroupInternal.selected.includes(item.id)
                              )
                            );
                          }}
                        />
                        <Button
                          label={t("admin.common.button.add")}
                          size="sm"
                          btnStyle="fill"
                          type="primary"
                          onClick={() => {
                            setEditUserInfo({
                              ...editUserInfo,
                              dept: {
                                code: targetData.id,
                                name: targetData.name,
                              },
                            });
                            setTargetData({
                              ...targetData,
                              type: "user",
                              state: "userInsert",
                            });
                            setPassword({
                              password1: "",
                              password2: "",
                              type: "RANDOM",
                            });
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                  <Table
                    classes="mg mt-8"
                    width={"100%"}
                    height={
                      (userDetail && userDetail.length > 0 ? height - 278 : 0) +
                      "px"
                    }
                    header={[
                      {
                        headerText: t("admin.dept.nameId"),
                        width: "calc(100% - 860px)",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.dept"),
                        width: "200px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.positionRole.position"),
                        width: "120px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.positionRole.job"),
                        width: "120px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.emailAddr"),
                        width: "200px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.phone"),
                        width: "120px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: "",
                        width: "100px",
                        order: "",
                        orderAction: () => {},
                      },
                    ]}
                    data={transformInternalUserList(
                      userDetail,
                      checkboxGroupInternal
                    )}
                    totalCount={userDetail ? userDetail.length : 0}
                    clickIds={checkboxGroupInternal.selected.map((index) =>
                      String(index)
                    )}
                    checkBoxClick={
                      targetData.state === "deptManagerUpdate"
                        ? undefined
                        : () =>
                            checkboxGroupInternal.handleAllClick(
                              checkboxGroupInternal.selected.length ===
                                userDetail.length
                                ? []
                                : userDetail.map((q: User) => q.id + "")
                            )
                    }
                    endReached={() => {}}
                    columnHeight="md"
                  />
                  {!(userDetail && userDetail.length > 0) && (
                    <Box
                      height={300}
                      alignItems="center"
                      width={"100%"}
                      justifyContent="center"
                      direction="column"
                    >
                      <img
                        src={require("../../shared/images/pages/File/noPeople.png")}
                        alt={"thumbnail"}
                      />
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        textAlign="center"
                      >
                        {t("admin.dept.noMembers")}
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
              {rightTab === 1 && (
                <Box direction="column">
                  <Box classes="adminDept-body-contents-body-deptList">
                    <Typography
                      type="body2_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.dept.subDeptCount", {
                        count:
                          deptDetail && deptDetail.length > 0
                            ? deptDetail.length
                            : 0,
                      })}
                    </Typography>
                  </Box>
                  <Table
                    classes="mg mt-8"
                    width={"100%"}
                    height={
                      (deptDetail && deptDetail.length > 0 ? height - 278 : 0) +
                      "px"
                    }
                    header={[
                      {
                        headerText: "",
                        width: "40px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.deptName"),
                        width: "calc(100% - 710px)",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.headDept"),
                        width: "300px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.subDept"),
                        width: "200px",
                        order: "",
                        orderAction: () => {},
                      },
                      {
                        headerText: t("admin.dept.deptMember"),
                        width: "200px",
                        order: "",
                        orderAction: () => {},
                      },
                    ]}
                    data={transformDeptList(deptDetail)}
                    totalCount={deptDetail ? deptDetail.length : 0}
                    endReached={() => {}}
                    columnHeight="md"
                  />
                  {!(deptDetail && deptDetail.length > 0) && (
                    <Box
                      height={300}
                      alignItems="center"
                      width={"100%"}
                      justifyContent="center"
                      direction="column"
                    >
                      <img
                        src={require("../../shared/images/pages/File/noPeople.png")}
                        alt={"thumbnail"}
                      />
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        textAlign="center"
                      >
                        {t("admin.dept.noSubDept")}
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          )}
          {checkUserState() === "INTERNAL_SEARCH" && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Box classes="adminDept-body-contents-body-externalList">
                <Typography
                  type="body2_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.countInternalUser", {
                    count:
                      internalSearch && internalSearch.length > 0
                        ? internalSearch.length
                        : 0,
                  })}
                </Typography>
                <Box>
                  <Button
                    label={t("admin.common.button.delete")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      checkboxGroupSearchInternal.selected.length === 0
                        ? "disable"
                        : "default"
                    }
                  />
                </Box>
              </Box>
              <Table
                classes="mg mt-8"
                width={"100%"}
                height={
                  (internalSearch && internalSearch.length > 0
                    ? height - 278
                    : 0) + "px"
                }
                header={[
                  {
                    headerText: t("admin.dept.nameId"),
                    width: "calc(100% - 860px)",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.dept"),
                    width: "200px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.positionRole.position"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.positionRole.job"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.emailAddr"),
                    width: "200px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.phone"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: "",
                    width: "100px",
                    order: "",
                    orderAction: () => {},
                  },
                ]}
                data={transformInternalUserList(
                  internalSearch,
                  checkboxGroupSearchInternal
                )}
                totalCount={internalSearch ? internalSearch.length : 0}
                clickIds={checkboxGroupSearchInternal.selected.map((index) =>
                  String(index)
                )}
                checkBoxClick={() =>
                  checkboxGroupSearchInternal.handleAllClick(
                    checkboxGroupSearchInternal.selected.length ===
                      userDetail.length
                      ? []
                      : userDetail.map((q: User) => q.id + "")
                  )
                }
                endReached={() => {}}
                columnHeight="md"
              />
              {!(internalSearch && internalSearch.length > 0) && (
                <Box
                  height={300}
                  alignItems="center"
                  width={"100%"}
                  justifyContent="center"
                  direction="column"
                >
                  <img
                    src={require("../../shared/images/pages/File/noPeople.png")}
                    alt={"thumbnail"}
                  />
                  <Typography
                    type="body2_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    textAlign="center"
                  >
                    {t("admin.dept.noSearchResult")}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
          {checkUserState() === "EXTERNAL" && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Box classes="adminDept-body-contents-body-externalList">
                <Typography
                  type="body2_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.countExternalUser", {
                    count:
                      externalDetail && externalDetail.length > 0
                        ? externalDetail.length
                        : 0,
                  })}
                </Typography>
                <Box>
                  <Button
                    label={t("admin.common.button.delete")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      checkboxGroupExternal.selected.length === 0
                        ? "disable"
                        : "default"
                    }
                    onClick={() => {
                      setDeleteUserInfo(
                        externalDetail
                          .filter((item) =>
                            checkboxGroupExternal.selected.includes(item.userId)
                          )
                          .map((item) => ({ id: item.userId } as User))
                      );
                    }}
                  />
                </Box>
              </Box>
              <Table
                classes="mg mt-8"
                width={"100%"}
                height={
                  (externalDetail && externalDetail.length > 0
                    ? height - 186
                    : 0) + "px"
                }
                header={[
                  {
                    headerText: t("admin.dept.emailAddr"),
                    width: "calc(100% - 760px)",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.name"),
                    width: "200px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.company"),
                    width: "200px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.phone"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.status"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: "",
                    width: "100px",
                    order: "",
                    orderAction: () => {},
                  },
                ]}
                data={transformExternalUserList(
                  externalDetail,
                  checkboxGroupExternal
                )}
                totalCount={externalDetail ? externalDetail.length : 0}
                clickIds={checkboxGroupExternal.selected.map((index) =>
                  String(index)
                )}
                checkBoxClick={() =>
                  checkboxGroupExternal.handleAllClick(
                    checkboxGroupExternal.selected.length ===
                      externalDetail.length
                      ? []
                      : externalDetail.map((q: Member) => q.userId + "")
                  )
                }
                endReached={() => {}}
                columnHeight="md"
              />
              {!(externalDetail && externalDetail.length > 0) && (
                <Box
                  height={300}
                  alignItems="center"
                  width={"100%"}
                  justifyContent="center"
                  direction="column"
                >
                  <img
                    src={require("../../shared/images/pages/File/noPeople.png")}
                    alt={"thumbnail"}
                  />
                  <Typography
                    type="body2_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    textAlign="center"
                  >
                    {t("admin.dept.noExternalUser")}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
          {checkUserState() === "EXTERNAL_SEARCH" && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Box classes="adminDept-body-contents-body-externalList">
                <Typography
                  type="body2_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.countExternalUser", {
                    count:
                      externalSearch && externalSearch.length > 0
                        ? externalSearch.length
                        : 0,
                  })}
                </Typography>
                <Box>
                  <Button
                    label={t("admin.common.button.delete")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      checkboxGroupSearchExternal.selected.length === 0
                        ? "disable"
                        : "default"
                    }
                    onClick={() => {
                      setDeleteUserInfo(
                        externalSearch
                          .filter((item) =>
                            checkboxGroupSearchExternal.selected.includes(
                              item.userId
                            )
                          )
                          .map((item) => ({ id: item.userId } as User))
                      );
                    }}
                  />
                </Box>
              </Box>
              <Table
                classes="mg mt-8"
                width={"100%"}
                height={
                  (externalSearch && externalSearch.length > 0
                    ? height - 186
                    : 0) + "px"
                }
                header={[
                  {
                    headerText: t("admin.dept.emailAddr"),
                    width: "calc(100% - 760px)",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.name"),
                    width: "200px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.company"),
                    width: "200px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.phone"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.status"),
                    width: "120px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: "",
                    width: "100px",
                    order: "",
                    orderAction: () => {},
                  },
                ]}
                data={transformExternalUserList(
                  externalSearch,
                  checkboxGroupSearchExternal
                )}
                totalCount={externalSearch ? externalSearch.length : 0}
                clickIds={checkboxGroupSearchExternal.selected.map((index) =>
                  String(index)
                )}
                checkBoxClick={() =>
                  checkboxGroupSearchExternal.handleAllClick(
                    checkboxGroupSearchExternal.selected.length ===
                      externalDetail.length
                      ? []
                      : externalDetail.map((q: Member) => q.userId + "")
                  )
                }
                endReached={() => {}}
                columnHeight="md"
              />
              {!(externalSearch && externalSearch.length > 0) && (
                <Box
                  height={300}
                  alignItems="center"
                  width={"100%"}
                  justifyContent="center"
                  direction="column"
                >
                  <img
                    src={require("../../shared/images/pages/File/noPeople.png")}
                    alt={"thumbnail"}
                  />
                  <Typography
                    type="body2_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    textAlign="center"
                  >
                    {t("admin.dept.noSearchResult")}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
          {checkUserState() === "INTERNAL_ACTIVE" && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Box classes="adminDept-body-contents-body-externalList">
                <Typography
                  type="body2_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.countInternalUser", {
                    count:
                      internalActive && internalActive.length > 0
                        ? internalActive.length
                        : 0,
                  })}
                </Typography>
                <Box>
                  <Button
                    label={t("admin.common.button.delete")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      checkboxGroupActiveInternal.selected.length === 0
                        ? "disable"
                        : "default"
                    }
                    onClick={() => {
                      setDeleteUserInfo(
                        internalActive
                          .filter((item) =>
                            checkboxGroupActiveInternal.selected.includes(
                              item.userId
                            )
                          )
                          .map((item) => ({ id: item.userId } as User))
                      );
                    }}
                  />
                </Box>
              </Box>
              <Table
                classes="mg mt-8"
                width={"100%"}
                height={
                  (internalActive && internalActive.length > 0
                    ? height - 186
                    : 0) + "px"
                }
                header={[
                  {
                    headerText: t("admin.dept.id"),
                    width: "calc(100% - 760px)",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.name"),
                    width: "300px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.lastAccessTime"),
                    width: "300px",
                    order: "",
                    orderAction: () => {},
                  },
                ]}
                data={transformActiveUserList(
                  internalActive,
                  checkboxGroupActiveInternal
                )}
                totalCount={internalActive ? internalActive.length : 0}
                clickIds={checkboxGroupActiveInternal.selected.map((index) =>
                  String(index)
                )}
                checkBoxClick={() =>
                  checkboxGroupActiveInternal.handleAllClick(
                    checkboxGroupActiveInternal.selected.length ===
                      internalActive.length
                      ? []
                      : internalActive.map((q: ActiveUser) => q.userId + "")
                  )
                }
                endReached={() => {}}
                columnHeight="md"
              />
              {!(internalActive && internalActive.length > 0) && (
                <Box
                  height={300}
                  alignItems="center"
                  width={"100%"}
                  justifyContent="center"
                  direction="column"
                >
                  <img
                    src={require("../../shared/images/pages/File/noPeople.png")}
                    alt={"thumbnail"}
                  />
                  <Typography
                    type="body2_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    textAlign="center"
                  >
                    {t("admin.dept.noLoginUser")}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
          {checkUserState() === "EXTERNAL_ACTIVE" && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Box classes="adminDept-body-contents-body-externalList">
                <Typography
                  type="body2_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.dept.countExternalUser", {
                    count:
                      externalActive && externalActive.length > 0
                        ? externalActive.length
                        : 0,
                  })}
                </Typography>
                <Box>
                  <Button
                    label={t("admin.common.button.delete")}
                    size="sm"
                    btnStyle="fill"
                    type="secondary"
                    state={
                      checkboxGroupActiveExternal.selected.length === 0
                        ? "disable"
                        : "default"
                    }
                    onClick={() => {
                      setDeleteUserInfo(
                        externalActive
                          .filter((item) =>
                            checkboxGroupActiveExternal.selected.includes(
                              item.userId
                            )
                          )
                          .map((item) => ({ id: item.userId } as User))
                      );
                    }}
                  />
                </Box>
              </Box>
              <Table
                classes="mg mt-8"
                width={"100%"}
                height={
                  (externalActive && externalActive.length > 0
                    ? height - 186
                    : 0) + "px"
                }
                header={[
                  {
                    headerText: t("admin.dept.id"),
                    width: "calc(100% - 760px)",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.name"),
                    width: "300px",
                    order: "",
                    orderAction: () => {},
                  },
                  {
                    headerText: t("admin.dept.lastAccessTime"),
                    width: "300px",
                    order: "",
                    orderAction: () => {},
                  },
                ]}
                data={transformActiveUserList(
                  externalActive,
                  checkboxGroupActiveExternal
                )}
                totalCount={externalActive ? externalActive.length : 0}
                clickIds={checkboxGroupActiveExternal.selected.map((index) =>
                  String(index)
                )}
                checkBoxClick={() =>
                  checkboxGroupActiveExternal.handleAllClick(
                    checkboxGroupActiveExternal.selected.length ===
                      externalActive.length
                      ? []
                      : externalActive.map((q: ActiveUser) => q.userId + "")
                  )
                }
                endReached={() => {}}
                columnHeight="md"
              />
              {!(externalActive && externalActive.length > 0) && (
                <Box
                  height={300}
                  alignItems="center"
                  width={"100%"}
                  justifyContent="center"
                  direction="column"
                >
                  <img
                    src={require("../../shared/images/pages/File/noPeople.png")}
                    alt={"thumbnail"}
                  />
                  <Typography
                    type="body2_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    textAlign="center"
                  >
                    {t("admin.dept.noLoginUser")}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
          {![
            "DEPT",
            "EXTERNAL",
            "INTERNAL_SEARCH",
            "EXTERNAL_SEARCH",
            "INTERNAL_ACTIVE",
            "EXTERNAL_ACTIVE",
          ].includes(checkUserState()) && (
            <Box direction="column" classes="adminDept-body-contents-body">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.dept.userInfo")}
              </Typography>
              {targetData.type === "user" && (
                <Box
                  classes="adminDept-body-contents-body-userInfo"
                  direction="column"
                >
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.userId")}
                      </Typography>
                      {checkUserState() === "INSERT" && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {["VIEW", "UPDATE"].includes(checkUserState()) ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.id}
                      </Typography>
                    ) : (
                      <InputField
                        value={editUserInfo.id}
                        placeholder=""
                        onChange={(e) => {
                          setEditUserInfo({
                            ...editUserInfo,
                            id: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.name")}
                      </Typography>
                      {["INSERT", "UPDATE"].includes(checkUserState()) && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.name}
                      </Typography>
                    ) : (
                      <InputField
                        value={editUserInfo.name}
                        placeholder=""
                        onChange={(e) => {
                          setEditUserInfo({
                            ...editUserInfo,
                            name: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.positionRole.position")}
                      </Typography>
                      {["INSERT", "UPDATE"].includes(checkUserState()) && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.position?.name}
                      </Typography>
                    ) : (
                      <Dropdown
                        btnSize="sm"
                        placeholder=" "
                        width={240}
                        buttonClick={buttonClick}
                        value={editUserInfo.position?.name}
                      >
                        {positionRoleState.positionList.map(
                          (item: PositionOrRoleDto) => (
                            <DropdownItem
                              label={item.name}
                              onClick={() => {
                                setEditUserInfo({
                                  ...editUserInfo,
                                  position: item,
                                });
                                changeButtonClick(buttonClick + 1);
                              }}
                            />
                          )
                        )}
                      </Dropdown>
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.positionRole.job")}
                      </Typography>
                      {["INSERT", "UPDATE"].includes(checkUserState()) && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.role?.name}
                      </Typography>
                    ) : (
                      <Dropdown
                        btnSize="sm"
                        placeholder=" "
                        width={240}
                        buttonClick={buttonClick}
                        value={editUserInfo.role?.name}
                      >
                        {positionRoleState.roleList.map(
                          (item: PositionOrRoleDto) => (
                            <DropdownItem
                              label={item.name}
                              onClick={() => {
                                setEditUserInfo({
                                  ...editUserInfo,
                                  role: item,
                                });
                                changeButtonClick(buttonClick + 1);
                              }}
                            />
                          )
                        )}
                      </Dropdown>
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.email")}
                      </Typography>
                      {["INSERT", "UPDATE"].includes(checkUserState()) && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.email}
                      </Typography>
                    ) : (
                      <InputField
                        value={editUserInfo.email}
                        placeholder=""
                        onChange={(e) => {
                          setEditUserInfo({
                            ...editUserInfo,
                            email: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.dept")}
                      </Typography>
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.dept?.name}
                      </Typography>
                    ) : (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {editUserInfo.dept.code === ROOT_DEPT_CODE
                          ? companyName
                          : editUserInfo.dept?.name}
                      </Typography>
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.phone")}
                      </Typography>
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {userInfo.phoneNumber}
                      </Typography>
                    ) : (
                      <InputField
                        value={editUserInfo.phoneNumber}
                        placeholder=""
                        onChange={(e) => {
                          setEditUserInfo({
                            ...editUserInfo,
                            phoneNumber: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.password")}
                      </Typography>
                    </Box>
                    {["VIEW", "UPDATE"].includes(checkUserState()) && (
                      <Box>
                        {isNewPassword ? (
                          <Box justifyContent="flex-end" width={"100%"}>
                            <Button
                              btnStyle="fill"
                              type="error"
                              size="sm"
                              label={t("admin.common.button.cancel")}
                              onClick={() => {
                                setIsNewPassword(false);
                                setPassword({
                                  password1: "",
                                  password2: "",
                                  type: "RANDOM",
                                });
                              }}
                            />
                            <Button
                              classes="mg ml-8"
                              btnStyle="fill"
                              size="sm"
                              label={t("admin.common.button.apply")}
                              onClick={() => {
                                changePassword();
                              }}
                            />
                          </Box>
                        ) : (
                          <Box justifyContent="flex-end" width={"100%"}>
                            <Button
                              btnStyle="line"
                              size="sm"
                              label={t("admin.dept.newPassword")}
                              onClick={() => {
                                setIsNewPassword(true);
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>

                  {(["INSERT"].includes(checkUserState()) || isNewPassword) && (
                    <Box>
                      <Box>
                        <Typography
                          type="subtitle2"
                          exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        >
                          {t("admin.dept.settingMethod")}
                        </Typography>
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      </Box>
                      <Box direction="row">
                        <Radio
                          label={t("admin.dept.createManually")}
                          check={password.type !== "RANDOM"}
                          onClick={() => {
                            setPassword({
                              password1: "",
                              password2: "",
                              type: "",
                            });
                          }}
                        />
                        <Radio
                          label={t("admin.dept.createAuto")}
                          check={password.type === "RANDOM"}
                          onClick={() => {
                            setPassword({
                              password1: "",
                              password2: "",
                              type: "RANDOM",
                            });
                          }}
                          classes="mg ml-24"
                        />
                      </Box>
                    </Box>
                  )}
                  {(["INSERT"].includes(checkUserState()) || isNewPassword) &&
                    password.type !== "RANDOM" && (
                      <Box>
                        <Box>
                          <Typography
                            type="subtitle2"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          >
                            {t("admin.dept.password")}
                          </Typography>
                          <Typography
                            exactColor={getColor("COLOR_TEXT_ERROR")}
                            classes="mg ml-4"
                          >
                            *
                          </Typography>
                        </Box>
                        <InputField
                          type="password"
                          value={password.password1}
                          placeholder={t("admin.dept.inputPassword")}
                          onChange={(e) => {
                            setPassword({
                              ...password,
                              password1: e.target.value,
                            });
                          }}
                          width={240}
                          disabled={password.type === "RANDOM"}
                        />
                      </Box>
                    )}
                  {(["INSERT"].includes(checkUserState()) || isNewPassword) &&
                    password.type !== "RANDOM" && (
                      <Box>
                        <Box>
                          <Typography
                            type="subtitle2"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          >
                            {t("admin.dept.checkPassword")}
                          </Typography>
                          <Typography
                            exactColor={getColor("COLOR_TEXT_ERROR")}
                            classes="mg ml-4"
                          >
                            *
                          </Typography>
                        </Box>
                        <InputField
                          type="password"
                          value={password.password2}
                          placeholder={t("admin.dept.reInputPassword")}
                          onChange={(e) => {
                            setPassword({
                              ...password,
                              password2: e.target.value,
                            });
                          }}
                          width={240}
                          disabled={password.type === "RANDOM"}
                        />
                      </Box>
                    )}
                </Box>
              )}
              {targetData.type === "externalUser" && (
                <Box
                  classes="adminDept-body-contents-body-userInfo"
                  direction="column"
                >
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.email")}
                      </Typography>
                      {checkUserState() === "INSERT" && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {["VIEW", "UPDATE"].includes(checkUserState()) ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {externalUserInfo.userId}
                      </Typography>
                    ) : (
                      <InputField
                        value={editExternalUserInfo.userId}
                        placeholder=""
                        onChange={(e) => {
                          setEditExternalUserInfo({
                            ...editExternalUserInfo,
                            userId: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.name")}
                      </Typography>
                      {["INSERT", "UPDATE"].includes(checkUserState()) && (
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      )}
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {externalUserInfo.userName}
                      </Typography>
                    ) : (
                      <InputField
                        value={editExternalUserInfo.userName}
                        placeholder=""
                        onChange={(e) => {
                          setEditExternalUserInfo({
                            ...editExternalUserInfo,
                            userName: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.company")}
                      </Typography>
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {externalUserInfo.deptName}
                      </Typography>
                    ) : (
                      <InputField
                        value={editExternalUserInfo.deptName}
                        placeholder=""
                        onChange={(e) => {
                          setEditExternalUserInfo({
                            ...editExternalUserInfo,
                            deptName: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.phone")}
                      </Typography>
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {externalUserInfo.phoneNumber}
                      </Typography>
                    ) : (
                      <InputField
                        value={editExternalUserInfo.phoneNumber}
                        placeholder=""
                        onChange={(e) => {
                          setEditExternalUserInfo({
                            ...editExternalUserInfo,
                            phoneNumber: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.etc")}
                      </Typography>
                    </Box>
                    {checkUserState() === "VIEW" ? (
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {externalUserInfo.etc}
                      </Typography>
                    ) : (
                      <InputField
                        value={editExternalUserInfo.etc}
                        placeholder=""
                        onChange={(e) => {
                          setEditExternalUserInfo({
                            ...editExternalUserInfo,
                            etc: e.target.value,
                          });
                        }}
                        width={240}
                      />
                    )}
                  </Box>
                  <Box>
                    <Box>
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.dept.password")}
                      </Typography>
                    </Box>
                    {["VIEW", "UPDATE"].includes(checkUserState()) && (
                      <Box>
                        {isNewPassword ? (
                          <Box justifyContent="flex-end" width={"100%"}>
                            <Button
                              btnStyle="fill"
                              type="error"
                              size="sm"
                              label={t("admin.common.button.cancel")}
                              onClick={() => {
                                setIsNewPassword(false);
                                setPassword({
                                  password1: "",
                                  password2: "",
                                  type: "RANDOM",
                                });
                              }}
                            />
                            <Button
                              classes="mg ml-8"
                              btnStyle="fill"
                              size="sm"
                              label={t("admin.common.button.apply")}
                              onClick={() => {
                                changePassword();
                              }}
                            />
                          </Box>
                        ) : (
                          <Box justifyContent="flex-end" width={"100%"}>
                            <Button
                              btnStyle="line"
                              size="sm"
                              label={t("admin.dept.newPassword")}
                              onClick={() => {
                                setIsNewPassword(true);
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>

                  {(["INSERT"].includes(checkUserState()) || isNewPassword) && (
                    <Box>
                      <Box>
                        <Typography
                          type="subtitle2"
                          exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        >
                          {t("admin.dept.settingMethod")}
                        </Typography>
                        <Typography
                          exactColor={getColor("COLOR_TEXT_ERROR")}
                          classes="mg ml-4"
                        >
                          *
                        </Typography>
                      </Box>
                      <Box direction="row">
                        <Radio
                          label={t("admin.dept.createManually")}
                          check={password.type !== "RANDOM"}
                          onClick={() => {
                            setPassword({
                              password1: "",
                              password2: "",
                              type: "",
                            });
                          }}
                        />
                        <Radio
                          label={t("admin.dept.createAuto")}
                          check={password.type === "RANDOM"}
                          onClick={() => {
                            setPassword({
                              password1: "",
                              password2: "",
                              type: "RANDOM",
                            });
                          }}
                          classes="mg ml-24"
                        />
                      </Box>
                    </Box>
                  )}
                  {(["INSERT"].includes(checkUserState()) || isNewPassword) &&
                    password.type !== "RANDOM" && (
                      <Box>
                        <Box>
                          <Typography
                            type="subtitle2"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          >
                            {t("admin.dept.password")}
                          </Typography>
                          <Typography
                            exactColor={getColor("COLOR_TEXT_ERROR")}
                            classes="mg ml-4"
                          >
                            *
                          </Typography>
                        </Box>
                        <InputField
                          type="password"
                          value={password.password1}
                          placeholder={t("admin.dept.inputPassword")}
                          onChange={(e) => {
                            setPassword({
                              ...password,
                              password1: e.target.value,
                            });
                          }}
                          width={240}
                          disabled={password.type === "RANDOM"}
                        />
                      </Box>
                    )}
                  {(["INSERT"].includes(checkUserState()) || isNewPassword) &&
                    password.type !== "RANDOM" && (
                      <Box>
                        <Box>
                          <Typography
                            type="subtitle2"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          >
                            {t("admin.dept.checkPassword")}
                          </Typography>
                          <Typography
                            exactColor={getColor("COLOR_TEXT_ERROR")}
                            classes="mg ml-4"
                          >
                            *
                          </Typography>
                        </Box>
                        <InputField
                          type="password"
                          value={password.password2}
                          placeholder={t("admin.dept.inputPassword")}
                          onChange={(e) => {
                            setPassword({
                              ...password,
                              password2: e.target.value,
                            });
                          }}
                          width={240}
                          disabled={password.type === "RANDOM"}
                        />
                      </Box>
                    )}
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminSetting;
